// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__1Nge2"};